module.exports = __webpack_public_path__ + "img/21.21ed3c01.gif";